import React, { useMemo, useCallback } from 'react';
import { CollectionManagementHeader } from 'components/common/general/CollectionManagementPanel';
import { observer } from 'mobx-react-lite';
import { debounce } from 'global/utils/debounce';
import { useQuoteAddEmployeesPageStore } from 'store/pages/quote/add-employees/pageStore';
import { useRootStore } from 'store/rootStore';
import { SubProgressFilterDropdown } from 'components/common/add-employees/SubProgressFilterDropdown';
import { HeaderSectionStyled } from './styles';
import { TABLE_MANAGEMENT_PANEL_TEST_IDS } from '../constants';
import { QuoteAddEmployeesDropdown } from '../QuoteAddEmployeesDropdown';

export const QuoteTableManagementPanel: React.FC = observer(() => {
  const { paginationDelegate, employees } = useQuoteAddEmployeesPageStore();
  const { domainStoreV2 } = useRootStore();

  const debouncedSearch = useMemo(
    () =>
      debounce((searchValue: string) => {
        paginationDelegate.setFilterValue('employeeName', searchValue);
      }, 300),
    [paginationDelegate],
  );

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      debouncedSearch(e.target.value);
    },
    [debouncedSearch],
  );

  return (
    <CollectionManagementHeader
      data-test-id={TABLE_MANAGEMENT_PANEL_TEST_IDS.COLLECTION_MANAGEMENT_HEADER}
      elementsTitle="employees"
      page={paginationDelegate.page}
      currentElements={employees.length}
      elementsPerPage={12}
      totalElements={paginationDelegate.totalElements}
      onSearch={handleSearch}
      searchInputPlaceholder="Employee Name"
      headerSection={
        <HeaderSectionStyled>
          <QuoteAddEmployeesDropdown
            data-test-id={TABLE_MANAGEMENT_PANEL_TEST_IDS.ADD_EMPLOYEES_DROPDOWN}
            availableAddEmployeesActions={domainStoreV2.availableAddEmployeesActions}
          />
          <SubProgressFilterDropdown paginationDelegate={paginationDelegate} />
        </HeaderSectionStyled>
      }
    />
  );
});
